import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

export const useLocale = () => {
  const { lng } = useParams<{ lng: string }>();
  const { i18n } = useTranslation();
  // In MF mode there is no /:lng URL segment — fall back to i18n.language
  // which MFRootLayout keeps in sync with the host's active language.
  return lng ?? i18n.language ?? "ar";
};
